import React from "react";
import DefaultLayout from "../template";

const PrivateRouter = () => {
  return <DefaultLayout />
};

export { PrivateRouter };
export default PrivateRouter;
